import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    this.showing = false
  }

  toggle() {
    this.showing = !this.showing
    this.contentTarget.classList.toggle("hidden", !this.showing)

    if (this.showing) {
      this.iconTarget.classList.remove("icon-arrow-down2")
      this.iconTarget.classList.add("icon-arrow-up2")
    } else {
      this.iconTarget.classList.remove("icon-arrow-up2")
      this.iconTarget.classList.add("icon-arrow-down2")
    }
  }
}